module.exports = __webpack_public_path__ + "media/images/avatar-2-c64cc8738f950a0493535825d5790410.jpg";